import configs from "@workspace/casino_config/siteConfigs";
import nativeRedirect from "@workspace/casino_pages/legacyLayer/shared/utils/router/nativeRedirect";
import { useCallback } from "react";
import parseNotificationLink from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/helpers/parseNotificationLink";

type Props = {
  context: WorkerContext;
  onClose: () => void;
  notification?: NotificationFragment;
};

const useHandleNotificationClick = ({
  notification,
  onClose,
  context,
}: Props) => {
  const { language, site } = context;
  const { isBridgeSite, defaultLang } = configs[site];
  const handleCloseNotificationClick = useCallback(async () => {
    if (!notification) {
      return;
    }
    onClose();
  }, [notification, onClose]);

  const handleNotificationClick = useCallback(async () => {
    if (!notification) {
      return;
    }

    if (
      notification.link?.includes("#deposit") ||
      notification.link?.includes("#withdraw")
    ) {
      window.dispatchEvent(new CustomEvent("openCashier"));
      return;
    }

    const parsedLink = parseNotificationLink(notification.link, isBridgeSite);
    nativeRedirect(parsedLink, language, defaultLang);
    onClose();
  }, [defaultLang, isBridgeSite, language, notification, onClose]);
  return { handleNotificationClick, handleCloseNotificationClick };
};

export default useHandleNotificationClick;
